'use client';

/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, PropsWithChildren, useCallback, useEffect } from 'react';
import Image from 'next/image';
import { getLocalStorage, setLocalStorage } from '@/common/localStorages';
import { Icon } from '@/components/atomic/Icon';
import Button from '@/components/Button';
import { withNoSSR } from '@/components/NoSSR';
import useForceUpdate from '@/hooks/forceUpdate';
import { getUTCNow } from '@/utils/date';
import {
  checkIsStandalone,
  checkIsWebView,
  getMobileDetect,
} from '@/utils/device';

interface IAddToHomeScreenContainerProps {}

const STORAGE_KEY = 'A2HS';

const items = [
  {
    label: 'در نوار پایین گزینه Share را انتخاب کنید.',
    icon: <Icon color="link" icon="share_outline" size={22} />,
  },
  {
    label: 'گزینه Add to Home Screen را فعال کنید.',
    icon: <Icon color="gray-100" icon="add_square" size={22} />,
  },
  {
    label: 'در قسمت بالا گزینه Add را انتخاب کنید.',
    icon: <Icon color="link" icon="add_word" size={22} />,
  },
];

const checkIsNotDesiredDevice = (): boolean => {
  const md = getMobileDetect();
  const isDesiredDevices = md.is('IOS') && md.is('Safari');
  return !isDesiredDevices;
};

const checkIsVisited = (): boolean => {
  return !!getLocalStorage(STORAGE_KEY);
};

const AddToHomeScreenContainer: FC<
  PropsWithChildren<IAddToHomeScreenContainerProps>
> = withNoSSR(({ children }) => {
  const forceUpdate = useForceUpdate();

  const handleClick = useCallback(() => {
    setLocalStorage(STORAGE_KEY, getUTCNow().toString());
    forceUpdate();
  }, []);

  useEffect(() => {
    window.addEventListener('appinstalled', handleClick);
    return () => window.removeEventListener('appinstalled', handleClick);
  }, []);

  if (
    checkIsWebView() ||
    checkIsStandalone() ||
    checkIsNotDesiredDevice() ||
    checkIsVisited()
  ) {
    return <>{children}</>;
  }

  return (
    <main className="z-[9999999998] flex flex-col items-center bg-[#fff] px-6 pt-12 page-full">
      <Image
        alt="کارگزاری مفید"
        height={78}
        src="https://s3.ir-thr-at1.arvanstorage.com/mofidapp/logo/logo.webp"
        width={78}
      />
      <div className="mb-[35px] mt-[26px] text-center text-sm font-demibold text-blue">
        وب اپلیکیشن مفید را به صفحه اصلی موبایل خود اضافه کنید
      </div>
      <div className="flex flex-col gap-y-6">
        {items.map(({ label, icon }, index) => (
          <div key={index} className="flex items-center gap-x-2.5">
            {icon}
            <div className="text-sm font-regular text-gray-100">
              {index + 1}- {label}
            </div>
          </div>
        ))}
      </div>

      <Button
        className="mb-8 mt-6 max-w-[500px]"
        isFullWidth
        onClick={handleClick}
      >
        متوجه شدم
      </Button>
      <div className="flex flex-col justify-center gap-y-0">
        {[1, 2, 3].map((number, index, array) => (
          <Icon
            key={number}
            color="#80D3CB"
            icon="chevron_down"
            size={32}
            style={{ opacity: number / array.length }}
          />
        ))}
      </div>
    </main>
  );
});

export default AddToHomeScreenContainer;
